export type ActivityColor = 'sun' | 'sky' | 'tomato' | 'grass' | 'bubble' | 'grape';
// Categories are user-managed via the CMS, so the type is a plain string.
export type ActivityCategory = string;

export interface Activity {
  id: string;
  name: string;
  desc: string;
  price: string;
  category: ActivityCategory;
  color: ActivityColor;
  image: string;
  featured?: boolean;
}

export const HOMEPAGE_MAX_FEATURED = 12;
export const HOMEPAGE_FALLBACK_COUNT = 8;
export const CATEGORY_MAX_LENGTH = 40;

export const ACTIVITY_COLORS: ActivityColor[] = ['sun', 'sky', 'tomato', 'grass', 'bubble', 'grape'];
// Used as a fallback if the API is unreachable on first load.
export const DEFAULT_CATEGORIES: ActivityCategory[] = ['Hoppborg', 'Hinderbana', 'Spel', 'Mat & Mys'];

// Tailwind-safe class maps — keeps JIT from purging dynamic strings.
export const COLOR_BG: Record<ActivityColor, string> = {
  sun: 'bg-sun',
  sky: 'bg-sky',
  tomato: 'bg-tomato',
  grass: 'bg-grass',
  bubble: 'bg-bubble',
  grape: 'bg-grape',
}